import { useState } from "react";
import { getFirestore, collection, addDoc } from "firebase/firestore";

export default function ProductForm({ onClose }) {
  const db = getFirestore();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!name) {
      setError("Please enter product name.");
      setLoading(false);
      return;
    }

    try {
      await addDoc(collection(db, "products"), {
        name,
        recipes: [] // no recipes initially
      });
      onClose();
    } catch (err) {
      setError("Failed to save product.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSave} className="p-6 border rounded shadow max-w-lg mx-auto">
      <h2 className="text-xl font-bold mb-4">Add New Product</h2>

      {error && <p className="text-red-500 mb-2">{error}</p>}

      <div className="mb-3">
        <label className="block mb-1">Product Name:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border p-2 rounded"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        {loading ? "Saving..." : "Save Product"}
      </button>

      <button
        type="button"
        onClick={onClose}
        className="ml-2 bg-gray-300 px-3 py-2 rounded hover:bg-gray-400"
      >
        Cancel
      </button>
    </form>
  );
}
